const Layout = () => import('@/layout/index.vue')

export default {
    path: '/system',
    component: Layout,
    redirect: '/system/update',
    name: 'System',
    meta: {
        title: '系统管理',
        icon: 'setting',
        auth: ['System']
    },
    children: [
        {
            path: 'update',
            name: 'SettingUpdate',
            component: () => import('@/views/setting/update/index.vue'),
            meta: {
                title: '更新管理',
                icon: 'setting-update',
                auth: ['SettingUpdate']
            }
        },
        {
            path: 'OEMmanagement',
            name: 'OEMmanagement',
            component: () => import('@/views/setting/OEMmanagement/index.vue'),
            meta: {
                title: 'OEM管理',
                icon: 'users',
                auth: ['OEMmanagement']
            }
        },
        {
            path: 'ApiRecord',
            name: 'ApiRecord',
            component: () => import('@/views/setting/ApiRecord/index.vue'),
            meta: {
                title: '接口请求记录',
                icon: 'users',
                auth: ['ApiRecord']
            }
        }
    ]
}
